export default {
  name: 'AdviceMixin',
  methods: {
      adviceLabelHelperFunction : function(sphereSize, status) {
        if (sphereSize == null || sphereSize === 0) {
          return 'Onzeker'
        } else {
          switch (sphereSize) {
            case 1:
              return 'Hou de vinger aan de pols.'
            case 2:
            case 3:
              if (status === true) {
                return 'Zoek de opportuniteit.'
              } else if (status === false) {
                return 'Pas hiervoor op.'
              }
              return false
            case 4:
            case 5:
              if (status === true) {
                return 'Hier zit toekomst in.'
              } else if (status === false) {
                return 'Tijd om je te weren.'
              }
              return false
            default:
              return false
          }
        }
      },
      adviceSublabelHelperFunction  : function(sphereSize, status) {
        if (sphereSize == null || sphereSize === 0) {
          return false
        } else {
          switch (sphereSize) {
            case 1:
              return 'Hou dit facet in de gaten, al lijkt hij nu nog niet zo belangrijk.'
            case 2:
            case 3:
              if (status === true) {
                return 'Je bent goed bezig, zoek naar mogelijkheden om hier nog sterker op in te spelen.'
              } else if (status === false) {
                return 'Dit wordt wellicht steeds belangrijker voor je start-up, bereid je hier op voor.'
              }
              return false
            case 4:
            case 5:
              if (status === true) {
                return 'Dit is een belangrijke succesfactor voor je bedrijf. Surf verder mee op de golf!'
              } else if (status === false) {
                return 'Dit is een belangrijke succesfactor voor je bedrijf, en toch ben je er niet klaar voor.'
              }
              return false
            default:
              return false
          }
        }
      }
  }
}
